export default {
  name: 'corrective',
  components: {},
  props: [],
  data () {
    return {
      checklist_items: [],
      loading: false,
      errors: []
    }
  },
  computed: {

  },
  mounted () {
    this.loading = true
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Report/getReportFix', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      this.loading = false
      this.checklist_items = res[0]
      this.$loading.complete()
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    onSave () {
      var data = []
      var endCorrectDate = this.$moment().format('YYYY-MM-DD')
      this.checklist_items.forEach(checklistItem => {
        var item = {}
        item.id = checklistItem.id
        item.corrective_date = checklistItem.corrective_date
        endCorrectDate = this.$moment(checklistItem.corrective_date).isAfter(endCorrectDate) ? checklistItem.corrective_date : endCorrectDate
        // data.push(item)
        data.push({
          id: checklistItem.id,
          corrective_date: checklistItem.corrective_date
        })
      })
      this.$loading.start()
      this.btn_submit = true
      console.log(data)
      this.$store.dispatch('Checklist/correctiveChecklist', {checklist: {id: this.$route.params.checklist_id}, end_corrective_date: this.$moment(endCorrectDate).format('YYYY-MM-DD'), checklist_item: data}).then(res => {
        console.log('Break', this.$route.params.checklist_id, endCorrectDate, data)
        this.$loading.complete()
        this.btn_submit = false
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$router.push('/checklist/list')
      }).catch(errors => {
        this.btn_submit = false
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/corrective/corrective.js